export default "__VITE_PUBLIC_ASSET__8008e173__"